import React from 'react';
import styled from 'styled-components';
import { Radio } from '@zocdoc-frontend-common/components-radio';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';
import { StandaloneLink } from '@zocdoc-mezzanine/components-link';
import { white } from '@zocdoc-mezzanine/foundations-colors';

export class AddSubpatientButton extends Radio {
    /**
     * used in SelectPatientRadioGroup to detect instances of this class when using
     * react-hot-loader
     */
    static displayName = 'AddSubpatientButton';

    render() {
        const {
            'data-test': dataTest,
            className,
            onClick,
            text,
            ...radioProps
        } = this.props;

        const attributes = filterToValidAttributes(radioProps);

        const standAloneOnClick = (e) => {
            e.stopPropagation();
            onClick();
        };

        return (
            <Container
                className={className}
                data-test={dataTest}
                role="button"
                {...attributes}
                onClick={onClick}
            >
                <StandaloneLink
                    data-test="add-subpatient-text"
                    id={this.id}
                    onClick={standAloneOnClick}
                >
                    {text}
                </StandaloneLink>
            </Container>
        );
    }
}

const Container = styled.div`
    background-color: ${white};
    box-sizing: border-box;
    cursor: pointer;
    height: 48px;
    margin: 0;
    padding: 16px;
    padding-right: 0;
    position: relative;
    width: 100%;
`;
